export const TOOLS_REDUCER_NAMES = {
  STATE: 'state',
  GEOCODER: 'geocoder',
  DRAW: 'draw',
  COMMON: 'common',
  BOUNDARY_GRID: 'boundary_grid',
  DOCUMENT_COORDINATES: 'document_coordinates',
};
